import React, { Component } from 'react';

import Header from "../Header/Header"
import Footer from "../Footer/Footer"
import Body from '../Body/Body';

export default class App extends Component {
  render() {
    return (
      <div className="App">
      <Header />
      <Body />
      <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/App/App.jsx